export default __webpack_public_path__ + "static/media/YAP.3da86728.png";